/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { dropTask } from 'ember-concurrency';

// not importing a test file, only app one with unfortunate "-test" filename suffix:
// eslint-disable-next-line ember/no-test-import-export
import NewsletterValidations from 'cio/utils/validations/newsletter-test';
import FormValidations from 'cio/utils/form-validations';
import NewsletterModel from 'cio/models/newsletter';
import { tracked } from '@glimmer/tracking';

interface NewslettersTestProgressArgs {
  newsletter: NewsletterModel;
  toggleSendToRemainingModal: () => unknown;
}
export default class NewslettersTestProgress extends Component<NewslettersTestProgressArgs> {
  validations: FormValidations;

  @tracked isEditingTest = false;
  @tracked isEditingSchedule = false;

  saveNewsletter = dropTask(async () => {
    try {
      await this.validations.validateModel();

      this.args.newsletter?.set('updateType', 'test');
      await this.args.newsletter?.save();

      this.isEditingTest = false;
    } catch (e) {
      // We get here if `validateModel` rejects, but it will
      // automatically set the errors object, so we do not need
      // to do anything here.
    }
  });

  @action
  stopEditingTest() {
    this.args.newsletter?.rollbackAttributes();
    this.isEditingTest = false;
  }

  constructor(owner: unknown, args: NewslettersTestProgressArgs) {
    super(owner, args);
    this.validations = FormValidations.create({
      validations: NewsletterValidations,
      context: this,
      modelKey: 'args.newsletter',
    });
  }
}
